import domain from './themes/domain';
import allhomes from './themes/allhomes';
import cre from './themes/cre';
import pricefinder from './themes/pricefinder';
import rta from './themes/rta';
export default {
  domain,
  allhomes,
  cre,
  pricefinder,
  rta
};